import { UpSales } from "../bundle/bundle";

export const getInteractionRepository = async (companyId, interactionId) => {
    let response = await UpSales.Interaction.getInteraction(companyId,interactionId);
    if (response.error) throw Error(response.message)
    return response;
  };